module.exports = __webpack_public_path__ + "static/media/bag.424725bd.png";